module.exports = __webpack_public_path__ + "static/media/slide-2-image.1c6747b2.svg";